import {
  WHITELIST_DETAILS_COLUMNS_WITHOUT_SPREAD,
  WHITELIST_DETAILS_COLUMNS_WITH_SPREAD,
} from './feature-columns/commercial/whitelist-details';
import {
  BCH_CONTRACT_REVISION_GENERATED_CONDITIONS,
  DEFAULT_CONTRACT_REVISION_GENERATED_CONDITIONS,
} from './feature-columns/commercial/contract-revision-conditions';

export const COMMERCIAL_PLATFORM_FEATURES = {
  COMMERCIAL_MASTER_ENTITY_SOURCE_FILTER: 'commercial.masterEntity.sourceFilter',
  UPDATE_EXTERNAL_DATA: 'commercial.updateExternalData',
  VIEW_CESSION_PREDICTIONS_MANAGER: 'commercial.viewCessionPredictionsManager',
  WHITELIST_DETAILS_VISIBLE_COLUMNS: 'commercial.whitelistDetails.visibleColumns',
  SHOW_CONTRACT_CREDIT_LINE: 'commercial.contractGeneration.showCreditLine',
  ALLOWED_CONTRACT_TYPES: 'commercial.contractTypes.allowed',
  CONTRACT_REVISION_GENERATED_CONDITIONS: 'commercial.contractRevision.generatedConditions',
};

export const COMMERCIAL_PLATFORM_FEATURE_CONFIG = {
  BCH: {
    [COMMERCIAL_PLATFORM_FEATURES.COMMERCIAL_MASTER_ENTITY_SOURCE_FILTER]: false,
    [COMMERCIAL_PLATFORM_FEATURES.UPDATE_EXTERNAL_DATA]: true,
    [COMMERCIAL_PLATFORM_FEATURES.VIEW_CESSION_PREDICTIONS_MANAGER]: false,
    [COMMERCIAL_PLATFORM_FEATURES.WHITELIST_DETAILS_VISIBLE_COLUMNS]:
      WHITELIST_DETAILS_COLUMNS_WITHOUT_SPREAD,
    [COMMERCIAL_PLATFORM_FEATURES.SHOW_CONTRACT_CREDIT_LINE]: true,
    [COMMERCIAL_PLATFORM_FEATURES.ALLOWED_CONTRACT_TYPES]: ['DIGITAL'],
    [COMMERCIAL_PLATFORM_FEATURES.CONTRACT_REVISION_GENERATED_CONDITIONS]:
      BCH_CONTRACT_REVISION_GENERATED_CONDITIONS,
  },
  SANTANDER: {
    [COMMERCIAL_PLATFORM_FEATURES.COMMERCIAL_MASTER_ENTITY_SOURCE_FILTER]: true,
    [COMMERCIAL_PLATFORM_FEATURES.UPDATE_EXTERNAL_DATA]: false,
    [COMMERCIAL_PLATFORM_FEATURES.VIEW_CESSION_PREDICTIONS_MANAGER]: true,
    [COMMERCIAL_PLATFORM_FEATURES.WHITELIST_DETAILS_VISIBLE_COLUMNS]:
      WHITELIST_DETAILS_COLUMNS_WITHOUT_SPREAD,
    [COMMERCIAL_PLATFORM_FEATURES.SHOW_CONTRACT_CREDIT_LINE]: false,
    [COMMERCIAL_PLATFORM_FEATURES.ALLOWED_CONTRACT_TYPES]: null,
    [COMMERCIAL_PLATFORM_FEATURES.CONTRACT_REVISION_GENERATED_CONDITIONS]:
      DEFAULT_CONTRACT_REVISION_GENERATED_CONDITIONS,
  },
  FINGO: {
    [COMMERCIAL_PLATFORM_FEATURES.COMMERCIAL_MASTER_ENTITY_SOURCE_FILTER]: true,
    [COMMERCIAL_PLATFORM_FEATURES.UPDATE_EXTERNAL_DATA]: false,
    [COMMERCIAL_PLATFORM_FEATURES.VIEW_CESSION_PREDICTIONS_MANAGER]: true,
    [COMMERCIAL_PLATFORM_FEATURES.WHITELIST_DETAILS_VISIBLE_COLUMNS]:
      WHITELIST_DETAILS_COLUMNS_WITHOUT_SPREAD,
    [COMMERCIAL_PLATFORM_FEATURES.SHOW_CONTRACT_CREDIT_LINE]: false,
    [COMMERCIAL_PLATFORM_FEATURES.ALLOWED_CONTRACT_TYPES]: null,
    [COMMERCIAL_PLATFORM_FEATURES.CONTRACT_REVISION_GENERATED_CONDITIONS]:
      DEFAULT_CONTRACT_REVISION_GENERATED_CONDITIONS,
  },
  ITAU: {
    [COMMERCIAL_PLATFORM_FEATURES.COMMERCIAL_MASTER_ENTITY_SOURCE_FILTER]: false,
    [COMMERCIAL_PLATFORM_FEATURES.UPDATE_EXTERNAL_DATA]: false,
    [COMMERCIAL_PLATFORM_FEATURES.VIEW_CESSION_PREDICTIONS_MANAGER]: true,
    [COMMERCIAL_PLATFORM_FEATURES.WHITELIST_DETAILS_VISIBLE_COLUMNS]:
      WHITELIST_DETAILS_COLUMNS_WITH_SPREAD,
    [COMMERCIAL_PLATFORM_FEATURES.SHOW_CONTRACT_CREDIT_LINE]: false,
    [COMMERCIAL_PLATFORM_FEATURES.ALLOWED_CONTRACT_TYPES]: null,
    [COMMERCIAL_PLATFORM_FEATURES.CONTRACT_REVISION_GENERATED_CONDITIONS]:
      DEFAULT_CONTRACT_REVISION_GENERATED_CONDITIONS,
  },
};
